/**
 * Default context-menu feature flags for Quill-based rich text (PromangRichTextEditor / WorkJournalRichEditor).
 * Merge overrides per screen; set `moveSelectionToPage` / `createPageWithSelection` and pass matching `on*` handlers when ready.
 */
export const DEFAULT_PROMANG_RICH_TEXT_CONTEXT_MENU = {
  cut: true,
  copy: true,
  paste: true,
  insertImage: true,
  moveSelectionToPage: false,
  createPageWithSelection: false,
};
